import {
  useDialogContext,
  type DialogRootProps,
  DialogRoot as ChakraDialogRoot,
  type DialogBackdropProps,
  DialogBackdrop as ChakraDialogBackdrop,
  type DialogPositionerProps as ChakraDialogPositionerProps,
  DialogPositioner as ChakraDialogPositioner,
  type DialogContentProps,
  DialogContent as ChakraDialogContent,
  type DialogActionTriggerProps as ChakraDialogActionTriggerProps,
  DialogActionTrigger as ChakraDialogActionTrigger,
} from '@chakra-ui/react/dialog';

export function DialogRoot({ children, ...props }: DialogRootProps) {
  return (
    <ChakraDialogRoot
      modal={false}
      lazyMount
      unmountOnExit
      {...props}
      restoreFocus={false}
      trapFocus={false}
      closeOnInteractOutside={false}
    >
      {children}
    </ChakraDialogRoot>
  );
}

export function DialogBackdrop({ children, ...props }: DialogBackdropProps) {
  return (
    <ChakraDialogBackdrop pos="absolute" boxSize="full" {...props}>
      {children}
    </ChakraDialogBackdrop>
  );
}

export interface DialogPositionerProps extends ChakraDialogPositionerProps {
  closeOnInteractOutside?: boolean;
}

export function DialogPositioner({
  children,
  onMouseDown,
  closeOnInteractOutside = true,
  ...props
}: DialogPositionerProps) {
  const { setOpen } = useDialogContext();
  return (
    <ChakraDialogPositioner
      pos="absolute"
      boxSize="full"
      {...props}
      onMouseDown={(...args) => {
        if (closeOnInteractOutside) {
          setOpen(false);
        }
        onMouseDown?.(...args);
      }}
    >
      {children}
    </ChakraDialogPositioner>
  );
}

export function DialogContent({ children, onMouseDown, ...props }: DialogContentProps) {
  return (
    <ChakraDialogContent
      {...props}
      onMouseDown={(e, ...args) => {
        e.stopPropagation();
        onMouseDown?.(e, ...args);
      }}
    >
      {children}
    </ChakraDialogContent>
  );
}

export interface DialogActionTriggerProps extends ChakraDialogActionTriggerProps {
  disabled?: boolean;
}

export function DialogActionTrigger({ children, disabled, ...props }: DialogActionTriggerProps) {
  if (disabled) {
    return children;
  }
  return <ChakraDialogActionTrigger {...props}>{children}</ChakraDialogActionTrigger>;
}
